import React, { Component } from "react";
import { producaov2 } from "../../services/apis";
import { Icon, Button, Header, Modal } from "semantic-ui-react";
import { Editor } from "react-draft-wysiwyg";
import { Container } from "../../components/Admin/TextEditor/styles";
import { EditorState, ContentState } from "draft-js";
import swal from "sweetalert";
import { stateToHTML } from "draft-js-export-html";
import htmlToDraft from "html-to-draftjs";
import MicRecorder from "mic-recorder-to-mp3";
import { ButtonArquivo } from "./DuvidasStyles";
import { verify_mobile } from "../../utils/Utils";

let blob = [];
let constraintObj = {
  audio: true,
  video: {
    facingMode: "user",
    width: { min: 640, ideal: 1280, max: 1920 },
    height: { min: 480, ideal: 720, max: 1080 },
  },
};

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

class DuvidaEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openRec: false,
      openVideoRec: false,
      // content: this.props.content,
      editorState: EditorState.createEmpty(),
      isRecording: false,
      anexarVideo: false,
      recordingVideo: false,
      blobURL: "",
      blobArchieve: "",
    };
  }

  componentDidMount() {
    const { content } = this.props;

    if (!content) {
      return;
    }

    const sanitizedContent = content
      .replaceAll("<figure>", "")
      .replaceAll("</figure>", "")
      .replaceAll(
        'height="auto" width="auto"',
        'style="position: relative; width: 90%; height: 90%;"'
      )
      .replaceAll(
        'alt="" height="" width=""',
        'style="position: relative; width: 90%; height: 90%;"'
      )
      .replaceAll(
        'alt="" height="90%" width="90%"',
        'style="position: relative; width: 90%; height: 90%;"'
      );

    const { contentBlocks, entityMap } = htmlToDraft(sanitizedContent);
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    const editorState = EditorState.createWithContent(contentState);

    this.setState({ editorState });
  }

  handleEditorStateChange = (editorState) => {
    this.setState({ editorState });
  };

  uploadAnexo = async (e, fileType) => {
    const handleFileType = (fileType) => {
      if (fileType === "vídeo") {
        return new File([blob], "teste.mp4", {
          type: "video/mp4",
          lastModified: Date.now(),
        });
      }

      if (fileType === "áudio") {
        return new File([this.state.blobArchieve], "teste.mp3", {
          type: "audio/mp3",
          lastModified: Date.now(),
        });
      }

      return null;
    };

    const handleFilePath = (fileType) => {
      if (fileType === "vídeo" || fileType === "áudio") {
        return "imagens-voitto/audios_voitto_connect";
      }

      return "ppas";
    };

    const data = new FormData();
    const file =
      fileType === "arquivo" ? e.target.files[0] : handleFileType(fileType);

    data.append("file", file);
    data.append("nome", `${Date.now()}`);
    data.append("path", handleFilePath(fileType));

    try {
      swal("Arquivo anexado!", "Seu arquivo foi anexado com êxito", "success");
      const urlPath = await producaov2.post("/upload", data);

      const base = urlPath.data.url.replace("%2F", "/");

      const html_current =
        stateToHTML(this.state.editorState.getCurrentContent()) +
        `
                <a style="color:blue;" target="_blank" href="${base}">
                    <b>Anexo de ${fileType}</b>
                </a>`;
      const { contentBlocks, entityMap } = htmlToDraft(html_current);
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      const editorState = EditorState.createWithContent(contentState);
      this.setState({ editorState, openVideoRec: false, openRec: false });
    } catch (err) {
      swal(
        "Problemas em anexar seu arquivo!",
        "Tivemos um problema ao anexar seu arquivo, por gentileza, tente novamente, se persistir, nos contate",
        "error"
      );
    }
  };

  activeVideo() {
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
      navigator.mediaDevices.getUserMedia = (constraintObj) => {
        let getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        if (!getUserMedia) {
          return Promise.reject(
            new Error("getUserMedia is not implemented in this browser")
          );
        }
        return new Promise((resolve, reject) => {
          getUserMedia.call(navigator, constraintObj, resolve, reject);
        });
      };
    } else {
      navigator.mediaDevices.enumerateDevices();
    }

    navigator.mediaDevices
      .getUserMedia(constraintObj)
      .then((mediaStreamObj) => {
        //connect the media stream to the first video element
        let video = document.querySelector("#vid1");
        if ("srcObject" in video) {
          video.srcObject = mediaStreamObj;
        } else {
          //old version
          video.src = window.URL.createObjectURL(mediaStreamObj);
        }

        video.play();

        video.onloadedmetadata = function (ev) {
          //show in the video element what is being captured by the webcam
          video.play();
        };

        //add listeners for saving video/audio
        let start = document.getElementById("btnStart");
        let stop = document.getElementById("btnStop");
        let vidSave = document.getElementById("vid2");
        let downloadButton = document.getElementById("downloadButton");
        let mediaRecorder = new MediaRecorder(mediaStreamObj);
        let chunks = [];

        start.addEventListener("click", (ev) => {
          mediaRecorder.start();
          this.setState({ recordingVideo: true, anexarVideo: false });
        });
        stop.addEventListener("click", (ev) => {
          mediaRecorder.stop();
          this.setState({ recordingVideo: false, anexarVideo: true });
        });
        mediaRecorder.ondataavailable = function (ev) {
          chunks.push(ev.data);
        };
        mediaRecorder.onstop = (ev) => {
          blob = [];
          blob = new Blob(chunks, { type: "video/mp4;" });
          chunks = [];
          let videoURL = window.URL.createObjectURL(blob);
          vidSave.src = videoURL;
        };
      });
    this.setState({ openVideoRec: true });
  }

  start = () => {
    const { isBlocked } = this.state;
    if (!isBlocked) {
      Mp3Recorder.start()
        .then(() => this.setState({ isRecording: true }))
        .catch((e) => console.error(e));
    }
  };

  stop = () => {
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        let blobArchieve = blob;
        const blobURL = URL.createObjectURL(blob);
        this.setState({ blobURL, isRecording: false, blobArchieve });
      });
  };

  sendMessage = () => {
    const { editorState } = this.state;
    this.props.sendResposta(stateToHTML(editorState.getCurrentContent()));
  };

  render() {
    const {
      editorState,
      openVideoRec,
      anexarVideo,
      recordingVideo,
      openRec,
      isRecording,
      blobURL,
    } = this.state;

    return (
      <div>
        <div style={{ display: "flex" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "32px",
              paddingTop: "16px",
            }}
          >
            <Button
              color="grey"
              onClick={() => this.setState({ openRec: true })}
              style={{ marginBottom: "16px" }}
            >
              <Icon name="microphone" />
              Enviar dúvida por áudio
            </Button>
            <Button onClick={() => this.activeVideo()} color="grey">
              <Icon name="video camera" />
              Enviar dúvida por vídeo
            </Button>

            <ButtonArquivo>
              <input
                type="file"
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  cursor: "pointer",
                }}
                onChange={(e) => this.uploadAnexo(e, "arquivo")}
              />
              <Icon name="file" />
              Anexar arquivo
            </ButtonArquivo>
          </div>

          <Container>
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              editorStyle={
                verify_mobile()
                  ? {
                      border: "1px solid rgba( 0, 0, 0, 0.5)",
                      borderRadius: "5px",
                      minHeight: "300px",
                      maxWidth: "90%",
                      margin: "auto",
                      textAlign: "justify",
                    }
                  : {
                      border: "1px solid rgba( 0, 0, 0, 0.5)",
                      borderRadius: "5px",
                      minHeight: "400px",
                      //   maxWidth: "50%",
                      textAlign: "justify",
                      overflow: "auto",
                    }
              }
              onEditorStateChange={this.handleEditorStateChange}
            />

            <div>
              Não se equeça de zipar (.zip) se for enviar mais de um arquivos !
            </div>

            <Button
              onClick={this.sendMessage}
              color="green"
              style={{ alignSelf: "flex-end" }}
            >
              Enviar
            </Button>
          </Container>
        </div>

        <Modal open={openVideoRec}>
          <Header icon="video" content={`Envie sua dúvida por vídeo`} />
          <Modal.Content>
            <center>
              <img
                width="200"
                src="https://files.voitto.com.br/ftp-files/assets/ckeditor2/plugins/mediarecorder/icons/logo.image"
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div>
                  <video
                    id="vid1"
                    style={{
                      width: 400,
                      height: 320,
                      display: anexarVideo == false ? "block" : "none",
                    }}
                    autoplay
                    muted
                  ></video>
                  <video
                    id="vid2"
                    style={{
                      width: 400,
                      height: 320,
                      display: anexarVideo == true ? "block" : "none",
                    }}
                    controls
                  ></video>
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    id="btnStart"
                    style={{
                      display: recordingVideo == false ? "block" : "none",
                    }}
                    color="grey"
                    icon
                    labelPosition="left"
                  >
                    <Icon name="video" />
                    Gravar Vídeo
                  </Button>
                  <Button
                    id="btnStop"
                    style={{
                      display: recordingVideo == true ? "block" : "none",
                    }}
                    color="red"
                    icon
                    labelPosition="left"
                  >
                    <Icon name="circle" />
                    Parar gravação
                  </Button>
                  <Button
                    disabled={anexarVideo == false}
                    onClick={(e) => this.uploadAnexo(e, "vídeo")}
                    color="grey"
                    icon
                    labelPosition="left"
                  >
                    <Icon name="check" />
                    Anexar resposta
                  </Button>
                </div>
              </div>
            </center>
          </Modal.Content>

          <Modal.Actions>
            <Button
              onClick={() => this.setState({ openVideoRec: false })}
              color="red"
              inverted
            >
              <Icon name="close" /> Fechar
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal open={openRec}>
          <Header icon="audio" content={`Envie sua dúvida por áudio`} />
          <Modal.Content>
            <center>
              <img
                width="200"
                src="https://files.voitto.com.br/ftp-files/assets/ckeditor2/plugins/mediarecorder/icons/logo.image"
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div>
                  {!isRecording ? (
                    <Button
                      onClick={this.start}
                      color="grey"
                      icon
                      labelPosition="left"
                    >
                      <Icon name="microphone" />
                      Gravar Áudio
                    </Button>
                  ) : (
                    <Button
                      onClick={this.stop}
                      color="red"
                      icon
                      labelPosition="left"
                    >
                      <Icon name="circle" />
                      Parar gravação
                    </Button>
                  )}
                  <Button
                    disabled={blobURL == ""}
                    onClick={(e) => this.uploadAnexo(e, "áudio")}
                    color="grey"
                    icon
                    labelPosition="left"
                  >
                    <Icon name="check" />
                    Anexar resposta
                  </Button>
                </div>
                <br />
                {isRecording ? (
                  <p>Gravando...</p>
                ) : (
                  <audio src={blobURL} controls="controls" />
                )}
              </div>
            </center>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => this.setState({ openRec: false })}
              color="red"
              inverted
            >
              <Icon name="close" /> Fechar
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default DuvidaEditor;
